import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TelemetryEventName } from '@app/@shared/enums';
import { Analysis, AssetClassificationType } from '@app/@shared/models/reverse-engineering/analysis.models';
import { TelemetryEvent } from '@app/@shared/models/telemetry-event';
import { Content } from '@app/@shared/services/content/content.model';
import { ContentService } from '@app/@shared/services/content/content.service';
import { QuicksightDashboardEmbed } from '@app/@shared/services/market-analysis/dashboard.models';
import { MetaService } from '@app/@shared/services/meta.service';
import { moduleNameFromUrl } from '@app/@shared/utils/common';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-asset-loader',
    templateUrl: './asset-loader.component.html',
    styleUrl: './asset-loader.component.scss',
    standalone: false
})
export class AssetLoaderComponent implements OnInit {
  @Input() assetId: string;
  @Input() analysisMetadata: Analysis;
  @Input() analysisCode: string;

  @Output() closeAssetViewer: EventEmitter<any> = new EventEmitter<any>();

  public assetContent: Content;
  public assetClassification = '';
  public quickSightDashboard: QuicksightDashboardEmbed;
  public channelId: string;
  public subscriptionId: string;

  constructor(
    private readonly contentService: ContentService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly metaService: MetaService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.contentService.getAssetContent(this.assetId),
      this.route.paramMap
    ]).pipe(
      tap(([content, routeParams]) => {
        this.channelId = routeParams.get('channelId');
        this.subscriptionId = routeParams.get('subscriptionId');
        this.assetClassification = content.assetClassification;
        if(this.assetClassification === AssetClassificationType.QUICKSIGHT) {
          this.buildQuicksightAsset(content);
        }
      })
    ).subscribe(([content]) => {
      this.assetContent = content;
      this.sendTelemetryEvent();
    });

  }

  public onCloseAssetViewer() {
    this.closeAssetViewer.emit();
  }

  private buildQuicksightAsset(asset: Content){
    this.quickSightDashboard = {
      embedUrl: asset.content.embedUrl,
      downloadEnabled: asset.downloadEnabled.data_grid,
      hasRawData: asset.content.hasRawData
    };
  }

  private sendTelemetryEvent(): void {
    if(this.assetClassification === AssetClassificationType.HTML) {
      const payload: any = {
        artifactName: this.assetContent.name,
        artifactType: 'text/html',
        channelId: this.channelId,
        downloadSizeBytes: 0,
        reportCode: this.analysisCode,
        reportId: this.assetContent.id,
        reportTitle: this.assetContent.name,
        subscriptionId: this.subscriptionId
      };
      const applicationModule = moduleNameFromUrl(this.router.url);
      const event = new TelemetryEvent(TelemetryEventName.EVENT_VIEW_IN_BROWSER, payload, applicationModule);
      this.metaService.postTelemetryEvent(event).subscribe();
    }
  }
}
